import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';

@Component({
  selector: 'app-mdl-delete-user',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mdl-delete-user.html',
  styleUrls: ['./mdl-delete-user.css']
})
export class MdlDeleteUserComponent {
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MdlDeleteUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: Api
  ) {}

  closeMdl(): void {
    this.dialogRef.close(false);
  }

  executeAction(): void {
    this.isLoading = true;
    
    if (this.data.mode === 'multiple-users') {
      this.dialogRef.close({
        action: this.data.action,
        userIds: this.data.userIds
      });
      return;
    }
    
    if (this.data.action === 'delete') {
      this.deleteUser();
    } else {
      this.changeUserStatus();
    }
  }

  private deleteUser(): void {
    this.api.deleteUser({ usuario_id: this.data.id }).subscribe({
      next: (response) => {
        console.log('Usuario eliminado correctamente', response);
        this.isLoading = false;
        this.dialogRef.close({ action: 'delete', success: true });
      },
      error: (error) => {
        console.error('Error al eliminar usuario', error);
        this.isLoading = false;
        this.dialogRef.close({ action: 'delete', success: false });
      }
    });
  }




   private changeUserStatus(): void {
  const nuevoEstado = this.data.action === 'activate' ? 1 : 0;
  
  const payload = { 
    usuario_id: this.data.id, 
    nombre: this.data.nombre || this.data.user?.nombre || '',
    apellido: this.data.apellido || this.data.user?.apellido || '',
    email: this.data.email || this.data.user?.email || '',
    rut: this.data.rut || this.data.user?.rut || '',
    rolId: this.data.rolId || this.data.user?.rolId || this.data.user?.rol?.id || 1,
    activo: nuevoEstado
  };


  if (!payload.nombre || !payload.email) {
    console.error('❌ Error: Faltan datos obligatorios del usuario');
    this.isLoading = false;
    this.dialogRef.close({ 
      action: this.data.action, 
      success: false,
      error: 'Faltan datos del usuario para actualizar'
    });
    return;
  }

  this.api.updateUser(payload).subscribe({
    next: (response) => {
      console.log('Estado de usuario actualizado correctamente', response);
      this.isLoading = false;
      this.dialogRef.close({ 
        action: this.data.action, 
        success: true,
        newStatus: nuevoEstado
      });
    },
    error: (error) => {
      console.error('Error al cambiar estado de usuario', error);
      this.isLoading = false;
      this.dialogRef.close({ 
        action: this.data.action, 
        success: false 
      });
    }
  });
}
}